import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

// Illustration from unDraw (always loads)
const ERROR_ILLUSTRATION =
  "https://cdn.jsdelivr.net/gh/undraw/undraw@latest/svg/undraw_page_not_found_re_e9o6.svg";

const fadeIn = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.75 } },
};

export default function ErrorPage() {
  return (
    <section className="min-h-screen bg-gradient-to-br from-blue-900 via-indigo-950 to-blue-300 flex flex-col justify-center items-center px-6">
      <motion.div
        className="max-w-lg w-full text-center bg-white/90 rounded-2xl shadow-2xl px-10 py-14 flex flex-col items-center"
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <motion.img
          src={ERROR_ILLUSTRATION}
          alt="404 not found"
          className="w-56 mx-auto mb-6"
          initial={{ opacity: 0, scale: 0.94 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2, duration: 0.8, type: "spring" }}
        />
        <h1 className="text-5xl font-extrabold mb-2 text-blue-900 tracking-tight">
          404
        </h1>
        <h2 className="text-2xl font-bold mb-4 text-yellow-500">
          Page Not Found
        </h2>
        <p className="mb-8 text-gray-700 text-lg">
          Sorry, the page you’re looking for doesn’t exist or has been moved.
          <br />
          If you believe this is an error, please{" "}
          <a
            href="mailto:sundeepsingh12478@gmail.com"
            className="text-blue-600 underline hover:text-blue-800"
          >
            contact support
          </a>
          .
        </p>
        <Link
          to="/"
          className="inline-block bg-blue-700 text-white font-semibold px-8 py-3 rounded-lg shadow-lg hover:bg-blue-800 transition text-lg"
        >
          Back to Home
        </Link>
      </motion.div>
    </section>
  );
}
